import React, { useRef } from 'react';
import clsx from 'clsx';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { ScrollActivator } from 'acq-components/lib/utils/ScrollActivator/ScrollActivator';
import stylesDefault from './__styles__/formView.scss?modules';

const FormBackNav = React.memo(({ content, onFormDismiss, qeId, formStyles }) => {
  const navElement = useRef(null);
  const styles = formStyles || stylesDefault;

  const scrollHandler = () => {
    let parentRect = null;
    if (
      typeof navElement?.current?.parentElement?.getBoundingClientRect === 'function'
    ) {
      parentRect = navElement.current.parentElement.getBoundingClientRect();
    }
    const topVal = Math.round(parentRect ? parentRect.top : 0);
    return topVal <= 60;
  };

  const backLink = content.find(item => item.key === 'mobileFormBackButton') || {};

  const clickHandler = () => {
    if (typeof onFormDismiss === 'function') {
      onFormDismiss();
      sendDTMClickEvent(backLink.dtm);
    }
  };

  return (
    <ScrollActivator onScroll={scrollHandler}>
      {activatedState => {
        const classNameVal = clsx(styles.closeFormNav, {
          [styles.sticky]: activatedState
        });
        return (
          <div
            ref={navElement}
            className={classNameVal}
            onClick={clickHandler}
            data-qe-id={`${qeId}-link`}
          >
            {backLink.title}
          </div>
        );
      }}
    </ScrollActivator>
  );
});

export { FormBackNav };
